import axios from 'axios';
import { CHAT_AUTH_HEADER } from './utilities/constants';
import { chatServiceUrl } from '@helpers';
import { readChatToken } from '../tokens';

let cachedChatToken = null;

const chatApi = axios.create({
  baseURL: chatServiceUrl(),
  headers: { 'Content-Type': 'application/json' },
  // Django creds not sent to service expecting JWT
  withCredentials: false,
});

export const setChatAuthToken = (token) => {
  cachedChatToken = token || null;

  if (cachedChatToken) {
    chatApi.defaults.headers.common[CHAT_AUTH_HEADER] = cachedChatToken;
  } else {
    delete chatApi.defaults.headers.common[CHAT_AUTH_HEADER];
  }
};

const getChatAuthToken = async () => {
  if (cachedChatToken) return cachedChatToken;

  const token = await readChatToken();
  setChatAuthToken(token);
  return token;
};

chatApi.interceptors.request.use(async (config) => {
  const headers = (config.headers ||= {});
  if (!headers[CHAT_AUTH_HEADER]) {
    headers[CHAT_AUTH_HEADER] = await getChatAuthToken();
  }
  return config;
});

chatApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalConfig = error?.config;

    if (status === 401 && originalConfig && !originalConfig.__retriedWithFreshToken) {
      originalConfig.__retriedWithFreshToken = true;

      const freshToken = await readChatToken();
      setChatAuthToken(freshToken);

      originalConfig.headers ||= {};
      originalConfig.headers[CHAT_AUTH_HEADER] = freshToken;

      return chatApi(originalConfig);
    }

    return Promise.reject(error);
  }
);

export default chatApi;
